import React,{useCallback,useEffect,useMemo,useRef,useState} from 'react';
import {Link,useLocation} from 'react-router-dom';
import Example from '../components/exampleNav';
import {ReadOnlyAccountProvider} from './AccountContext';
import {ReadOnlyFavoritesProvider} from '../favorites/FavoritesContext';
import {AccountCabinetBody} from './AccountPage';
import {AccountOrderActions,AccountOrderContent} from './AccountOrderPage';
import {AccountViewProvider} from './AccountViewContext';
import {createPreviewApi} from './admin-preview-api';

function PreviewDetails({order,api,onExpired}) {
  const [state,setState]=useState({loading:true,order:null,error:''});
  useEffect(()=>{let active=true;api.getHistoryOrder(order).then(value=>{if(active)setState({loading:false,order:value,error:''});}).catch(error=>{if(active)setState({loading:false,order:null,error:error.message});});return()=>{active=false;};},[order,api]);
  return <><h1 className="other-store-title account-title">Ваш заказ</h1>
    {state.loading?<p className="other-store-codes-status">Загружаем заказ…</p>:null}
    {state.error?<p className="other-store-error" role="alert">{state.error}</p>:null}
    {state.order?<AccountOrderContent order={state.order} onUnauthorized={onExpired}/>:null}
    <AccountOrderActions backTo="/account/preview" readOnly /></>;
}
export default function AdminAccountPreview() {
  const location=useLocation();
  const token=useRef(window.location.hash.slice(1));
  const [metadata,setMetadata]=useState(null),[error,setError]=useState(''),[ended,setEnded]=useState(false);
  const [favorites,setFavorites]=useState(null),[favoritesError,setFavoritesError]=useState(false),[closing,setClosing]=useState(false);
  const expire=useCallback(()=>{token.current='';setMetadata(null);setFavorites(null);setEnded(true);},[]);
  const api=useMemo(()=>createPreviewApi(token.current,expire),[expire]);
  useEffect(()=>{
    window.history.replaceState(null,'',window.location.pathname+window.location.search);
    if(!token.current){setError('Откройте просмотр из административной панели.');return undefined;}
    let active=true;
    api.metadata().then(data=>{if(active)setMetadata(data);}).catch(e=>{if(active)setError(e.message);});
    return()=>{active=false;};
  },[api]);
  useEffect(()=>{
    if(!metadata)return undefined;
    const delay=Date.parse(metadata.expiresAt)-Date.now();if(!Number.isFinite(delay) || delay<=0){expire();return undefined;}
    const timer=window.setTimeout(expire,delay);let active=true;
    api.getFavorites().then(items=>{if(active)setFavorites(items);}).catch(()=>{if(active)setFavoritesError(true);});
    return()=>{active=false;window.clearTimeout(timer);};
  },[metadata,api,expire]);
  const end=async()=>{setClosing(true);try{await api.close();expire();}catch(e){setError(e.message);}finally{setClosing(false);}};
  const account=useMemo(()=>metadata?{email:metadata.email}:null,[metadata]);
  const view=useMemo(()=>({api,readOnly:true,orderPath:row=>row.source==='bot'?`/account/preview/order/bot/${row.shop}/${row.billId}`:`/account/preview/order/visoria/${encodeURIComponent(row.orderId)}`}),[api]);
  const selected=useMemo(()=>{
    const bot=location.pathname.match(/^\/account\/preview\/order\/bot\/(eshop|psn|steam)\/(\d+)\/?$/);
    if(bot)return {source:'bot',shop:bot[1],billId:bot[2]};
    const visoria=location.pathname.match(/^\/account\/preview\/order\/visoria\/([^/]+)\/?$/);
    return visoria?{source:'visoria',orderId:decodeURIComponent(visoria[1])}:null;
  },[location.pathname]);
  if(ended)return <section className="content-block"><h1 className="other-store-title">Просмотр завершён</h1><p className="other-store-description">Откройте новый просмотр из административной панели.</p></section>;
  if(!metadata)return <section className="content-block"><p className="other-store-description" role="status">{error || 'Проверяем право административного просмотра…'}</p></section>;
  return <AccountViewProvider value={view}><ReadOnlyAccountProvider account={account}><ReadOnlyFavoritesProvider items={favorites || []}>
    <div className="mx-auto w-full max-w-7xl">
      <div className="account-history-notice mt-2" role="status">Просмотр кабинета <strong>{metadata.email}</strong> · Режим администратора · Только чтение · До {new Date(metadata.expiresAt).toLocaleTimeString('ru-RU',{hour:'2-digit',minute:'2-digit'})}{' '}
        <button type="button" className="account-link-btn" disabled={closing} onClick={end}>Завершить просмотр</button>
      </div>
      {error?<p className="other-store-error" role="alert">{error}</p>:null}
      <header className="content-block"><Example/></header>
      <main className="content-block mt-2">
        <nav className="other-store-breadcrumb"><Link to="/" className="other-store-breadcrumb-link">Главная</Link><span>/</span><span>Кабинет</span></nav>
        <div className="other-store-order-card account-card">
        {selected?<PreviewDetails key={location.pathname} order={selected} api={api} onExpired={expire}/>:<>
          <h1 className="other-store-title account-title">Личный кабинет</h1>
          <AccountCabinetBody account={account} onUnauthorized={expire} readOnly favoritesContent={favoritesError?<p className="account-history-notice mt-4" id="account-favorites-title">Избранное недоступно: административный API Visoria не подключён или временно не отвечает.</p>:favorites===null?<p className="other-store-codes-status mt-4" id="account-favorites-title">Загружаем избранное…</p>:undefined}/>
        </>}
      </div></main>
    </div>
  </ReadOnlyFavoritesProvider></ReadOnlyAccountProvider></AccountViewProvider>;
}
